import { render, staticRenderFns } from "./ListForm.vue?vue&type=template&id=53e5dfcb&scoped=true"
import script from "./ListForm.vue?vue&type=script&lang=js"
export * from "./ListForm.vue?vue&type=script&lang=js"
import style0 from "./ListForm.vue?vue&type=style&index=0&id=53e5dfcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e5dfcb",
  null
  
)

export default component.exports